// extracted by mini-css-extract-plugin
export var back_btns = "blogDetailInfo-module--back_btns--a9a28";
export var blog_detail = "blogDetailInfo-module--blog_detail--b6380";
export var blog_detail_left = "blogDetailInfo-module--blog_detail_left--d62d8";
export var blog_detail_right = "blogDetailInfo-module--blog_detail_right--a589c";
export var blog_detail_wrapper = "blogDetailInfo-module--blog_detail_wrapper--9bb3e";
export var blog_info_right = "blogDetailInfo-module--blog_info_right--08623";
export var blog_listing = "blogDetailInfo-module--blog_listing--51c82";
export var breadcrumbs = "blogDetailInfo-module--breadcrumbs--a3b6a";
export var commentBox = "blogDetailInfo-module--commentBox--89e7b";
export var commentInfo = "blogDetailInfo-module--commentInfo--af49e";
export var commentListbox = "blogDetailInfo-module--commentListbox--7c539";
export var commentTitle = "blogDetailInfo-module--commentTitle--42e20";
export var mobile_heading = "blogDetailInfo-module--mobile_heading--25f25";
export var shortName = "blogDetailInfo-module--shortName--b5971";
export var wrapperBlogContent = "blogDetailInfo-module--wrapperBlogContent--4b638";